export const expandedWideRoutesChecks: ((url: string) => boolean)[] = [
  (url) => url.startsWith('/documents/') && url !== '/documents',
  (url) => '/superuser/edge-transactions' == url,
  (url) => url.startsWith('/annual-statements/') && url.includes('step'),
  (url) => url.startsWith('/asic-invoices/'),
  (url) => url.startsWith('/imported-document/'),
  (url) => url.startsWith('/imported-annual-statement/'),
];

export function isExpandedPage(url: string): boolean {
  return expandedWideRoutesChecks.some((checkFn) => checkFn(url));
}
